import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../hooks/useAuth';
import { useSpace } from '../../../../hooks/useSpace';
import { isPlainLeftClick } from '../../../../utils/isPlainLeftClick';

const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  board_member: 'Conseil syndical',
  reader: 'Lecteur',
};

export function useSpaceSelectionPage() {
  const { memberships, switchSpace, isLoading } = useSpace();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  function handleSelect(event: MouseEvent<HTMLAnchorElement>, slug: string) {
    switchSpace(slug);
    if (!isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    navigate(`/spaces/${slug}`);
  }

  function handleSignOut() {
    void signOut();
  }

  const spaces = memberships.map((membership) => ({
    id: membership.space.id,
    name: membership.space.name,
    href: `/spaces/${membership.space.slug}`,
    roleLabel: ROLE_LABELS[membership.role] ?? membership.role,
    handleClick: (event: MouseEvent<HTMLAnchorElement>) => handleSelect(event, membership.space.slug),
  }));

  return {
    isLoading,
    spaces,
    handleSignOut,
  };
}
